import api from "./axiosInstance";
import networkConfig from "../utils/networkConfig";

export const createContactQuery = (data) => {
  return api.post("/api/contact-queries/createQuery", data);
};

export const getAllContactQueries = async (
  page = 1,
  limit = 10,
  search = "",
) => {
  // return api.get(
  //   `/api/contact-queries/getAllquery?page=${page}&limit=${limit}&search=${search}`
  // );
  const params = {};
  if (page) params.page = page;
  if (limit) params.limit = limit;
  if (search) params.search = search;
  const res = await api.get(networkConfig.support, { params });
  return res.data;
};

export const getContactQueryById = (id) => {
  return api.get(`/api/contact-queries/getById/${id}`);
};

export const deleteContactQueryById = (id) => {
  return api.delete(`/api/contact-queries/deleteById/${id}`);
};
